import classNames from 'classnames';
import SiteLink from 'components/shared/sitelink/sitelink';
import styles from './attributeTag.module.scss';

const AttributeTag = ({ className, link, locale }) => {
  const hasLink = link?.slug || link?.externalLink;

  const classes = classNames(className, styles.attributeTag, {
    [styles.attributeTagLink]: hasLink,
  });

  if (hasLink) {
    return (
      <SiteLink
        href={link.slug}
        external={link.externalLink}
        locale={locale}
        className={classes}
      >
        {link.title}
      </SiteLink>
    );
  }

  return <div className={classes}>{link.title}</div>;
};

export default AttributeTag;
